// Catalog cart bundle
import '../css/pages/catalog/cart/cart.css';

import { runLegacy } from './helpers/load-legacy';
import cartViewJs        from '../js/pages/catalog/cart/view.js?legacy';
import bootstrapTooltipJs from '../js/vendor/bootstrap-tooltip.js?legacy';

runLegacy(
    cartViewJs,
    bootstrapTooltipJs,
);
